import type { ReactNode } from "react";

export type BoldProps = ReactNode;

function Bold(children: BoldProps) {
  return <span className="__bold">{children}</span>;
}

export default Bold;
